var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19,
  stroke: "#fff",
  fill: "#fff"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0Zm6.913 21.06-10 6.25A1.25 1.25 0 0 1 15 26.25v-12.5a1.25 1.25 0 0 1 1.913-1.06l10 6.25a1.251 1.251 0 0 1 0 2.12Z"
})));
export { SvgPlayButton as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8Y2lyY2xlIGN4PSIyMCIgY3k9IjIwIiByPSIxOSIgc3Ryb2tlPSIjZmZmZmZmIiBzdHJva2VXaWR0aD0iMiIgZmlsbD0iI2ZmZmZmZiIgLz4KICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0yMCAwQzguOTU0IDAgMCA4Ljk1NCAwIDIwczguOTU0IDIwIDIwIDIwIDIwLTguOTU0IDIwLTIwUzMxLjA0NiAwIDIwIDBabTYuOTEzIDIxLjA2LTEwIDYuMjVBMS4yNSAxLjI1IDAgMCAxIDE1IDI2LjI1di0xMi41YTEuMjUgMS4yNSAwIDAgMSAxLjkxMy0xLjA2bDEwIDYuMjVhMS4yNTEgMS4yNTEgMCAwIDEgMCAyLjEyWiIvPgo8L3N2Zz4K";